import React from 'react';

const LogoIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="50" cy="50" r="50" />
    <text 
      x="50%" 
      y="50%" 
      textAnchor="middle" 
      dominantBaseline="central" 
      fill="white" 
      fontSize="50" 
      fontFamily="Lexend, sans-serif" 
      fontWeight="bold"
    >
      82
    </text>
  </svg>
);

export default LogoIcon;
